import { Col, Row } from "reactstrap"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import styles from "./BulkUpload.module.scss"
import ActionDropdown from "../../../common/AdminCommonComponents/Buttons/ActionDropdown/ActionDropdown"
import DynamicDatatable from "../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import { useRef, useState } from "react"
import { FaTrash } from "react-icons/fa";

const BulkUpload = () => {
  const [csvFile, setCsvFile] = useState(null)
  const fileInputRef = useRef(null)

  const actions = [
    { label: "View detail", action: () => console.log("View Details") },
    { label: "Edit", action: () => console.log("Edit") },
    { label: "Change Status", action: () => console.log("Change Status") },
    { label: "Delete", action: () => console.log("Delete") },
  ]

  const data = [
    {
      attributeId: "#12346",
      attributeName: "Color",
      type: "Dropdown",
      category: "Clothing",
      subCategories: "Men’s Pants, Women’s Dresses",
      values: "Red, Blue, Green",
      status: "Active",
    },
    {
      attributeId: "#12346",
      attributeName: "Size",
      type: "Dropdown",
      category: "Clothing",
      subCategories: `T-Shirts Pants`,
      values: "S, M, L, XL",
      status: "Active",
    },
    {
      attributeId: "#12346",
      attributeName: "Color",
      type: "Dropdown",
      category: "Clothing",
      subCategories: "Men’s Pants, Women’s Dresses",
      values: "Red, Blue, Green",
      status: "Inactive",
    },
    {
      attributeId: "#12346",
      attributeName: "Color",
      type: "Dropdown",
      category: "Clothing",
      subCategories: "Men’s Pants, Women’s Dresses",
      values: "Red, Blue, Green",
      status: "Active",
    },
  ]

  const columns = [
    { name: "Attribute ID", selector: (row) => row.attributeId },
    { name: "Attribute Name", selector: (row) => row.attributeName },
    { name: "Type", selector: (row) => row.type },
    { name: "Category", selector: (row) => row.category },
    { name: "Sub categories", selector: (row) => row.subCategories },
    { name: "Values", selector: (row) => row.values },
    { name: "Status", selector: (row) => row.status },
    { name: "Action", cell: () => <ActionDropdown options={actions} /> },
  ]

  const handleOpenFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const handleSetFile = (event) => {
    setCsvFile(event.target.files[0])
  }

  const handleRemoveFile = () => {
    setCsvFile(null)
  }

  return (
    <div className="shadow bg-white p-3 mt-3">
      <div className="mb-3 fw-semibold fs-4">Bulk Upload</div>
      <DynamicButton theme="blue-gray">Download Template</DynamicButton>
      <DynamicButton theme="sky-blue" className="ms-3" onClick={handleOpenFile}>
        Upload CSV
      </DynamicButton>
      <input type="file" accept=".csv" className="d-none" ref={fileInputRef} onChange={handleSetFile} />
      {csvFile && <label className="ms-2 d-flex-inline align-items-center gap-2">{csvFile.name} <button onClick={handleRemoveFile} className={styles['btn']}><FaTrash size={16}/></button></label>}

      <Row className="mt-3">
        <Col sm={8} md={6} lg={4}>
          <div className={`rounded p-3 ${styles["colored-bg"]}`}>
            <div className="fw-semibold fs-5">Template Data</div>
            <ul className="mb-0">
              <li>Attribute Name</li>
              <li>Attribute Type</li>
              <li>Category</li>
              <li>Subcategories <br /> (comma-separated for multiple subcategories)</li>
              <li>Values <br /> (comma-separated for dropdown attributes)</li>
              <li>Status</li>
            </ul>
          </div>
        </Col>
      </Row>

      <div className="fw-semibold fs-5 my-3">Upload Preview</div>

      <DynamicDatatable data={data} columns={columns} type="yellow" />
    </div>
  )
}

export default BulkUpload
